import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';

const Popup = () => {
  const [popup, setPopup] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchPopup();
  }, []);

  const fetchPopup = async () => {
    try {
      const response = await axios.get('/api/popups/active');
      if (response.data) {
        setPopup(response.data);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Error fetching popup:', error);
    }
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleImageClick = () => {
    if (popup && popup.link_url) {
      window.open(popup.link_url, '_blank', 'noopener,noreferrer');
    }
  };

  if (!showPopup || !popup) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative bg-gradient-to-br from-navy-800 to-navy-900 rounded-2xl shadow-2xl border-2 border-gold/30 p-4 max-w-md w-full mx-4">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute -top-3 -right-3 bg-navy-900 hover:bg-gold text-white hover:text-navy-900 transition-colors z-10 rounded-full p-2 border-2 border-gold/50 shadow-lg"
          aria-label="Kapat"
        >
          <FaTimes className="w-4 h-4" />
        </button>

        {/* Popup Image */}
        <div 
          className={`relative ${popup.link_url ? 'cursor-pointer' : ''}`}
          onClick={popup.link_url ? handleImageClick : undefined}
        >
          <img
            src={popup.image_url && popup.image_url.startsWith('http') ? popup.image_url : popup.image_url || ''}
            alt="Popup"
            className="w-full h-auto object-contain rounded-lg"
          />
          {popup.link_url && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/0 hover:bg-black/10 transition-colors rounded-lg">
              <div className="opacity-0 hover:opacity-100 transition-opacity bg-gold/20 px-4 py-2 rounded-lg">
                <span className="text-white font-semibold">Tıklayarak ziyaret et</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;
